import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { IGameController } from '@/components/game/_domain/models/game-controller';
import { IGameRepresentationChangedArgs } from '@/components/game/_domain/models';

@Component({
  name: 'NextGameComponent',
})

export default class NextGameComponent extends TombolaBaseComponent {
  @Prop() public gameController: IGameController;
  private nextGameCountdown: number = 0;
  private nextGameCountdownAsString: string = '';
  private isNextGameALinkedGame: boolean = false;

  private mounted() {
    Vue.nextTick(() => {
      this.gameController.onNextGameRepresentationChanged(this.handleNextGameRepresentationChanged);
      setInterval(this.countdownToNextGameInSeconds, 1000);
    });
  }

  private handleNextGameRepresentationChanged(eventArgs: IGameRepresentationChangedArgs) {
    const nextGameInfo = eventArgs.currentGameRepresentation.nextGame;
    if (nextGameInfo) {
      this.nextGameCountdown = nextGameInfo.countDownToNextGameInSeconds;
      this.isNextGameALinkedGame = nextGameInfo.isLinkedGame;
      this.updateTimeLabel();
    }
  }

  private countdownToNextGameInSeconds() {
    if (this.nextGameCountdown > 0) {
      this.nextGameCountdown = this.nextGameCountdown - 1;
      this.updateTimeLabel();
    }
  }

  private updateTimeLabel() {
    const inMins = Math.floor(this.nextGameCountdown / 60);
    const seconds = this.nextGameCountdown % 60;
    this.nextGameCountdownAsString = `${inMins}:${seconds.toString().padStart(2, '0')}`;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/_default/_components/next-game/next-game.component.ts